const PREFIX = 'insights_'
export const LOADING = PREFIX + 'LOADING'
export const UPDATE_ALL = PREFIX + 'UPDATE_ALL'
export const UPDATE_BY_ID = PREFIX + 'UPDATE_BY_ID'